// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
    background: #f3f3f1;
    border-top: 1px solid rgba(17, 17, 17, 0.14);
    color: #171717;
}

.site-footer__shell {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1360px;
    padding: 0 24px;
    width: 100%;
}

.site-footer > .site-footer__shell:first-child {
    align-items: center;
    display: grid;
    gap: clamp(48px, 7vw, 104px);
    grid-template-columns: minmax(240px, 0.8fr) minmax(480px, 1.2fr);
    padding-bottom: 48px;
    padding-top: 48px;
}

.site-footer__brand {
    display: block;
    width: clamp(220px, 18vw, 280px);
}

.site-footer__brand img {
    aspect-ratio: 254 / 30;
    display: block;
    height: auto;
    width: 100%;
}

.site-footer__identity {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.site-footer__socials {
    display: flex;
    gap: 8px;
    margin-top: 24px;
}

.site-footer__social-link {
    align-items: center;
    color: #171717;
    display: inline-flex;
    height: 36px;
    justify-content: center;
    transition: opacity 0.2s ease;
    width: 36px;
}

.site-footer__social-link:hover {
    opacity: 0.6;
}

.site-footer__social-link[aria-disabled="true"] {
    cursor: default;
}

.site-footer__columns {
    display: grid;
    gap: clamp(40px, 5vw, 80px);
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-self: end;
    max-width: 720px;
    width: 100%;
}

.site-footer__group-title {
    color: #171717;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0;
    margin: 0 0 22px;
}

.site-footer__links {
    display: grid;
    gap: 13px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.site-footer__link {
    color: #171717;
    display: inline-block;
    font-size: 14px;
    line-height: 1.45;
    text-decoration: none;
    text-decoration-thickness: 1px;
    text-underline-offset: 4px;
    transition: opacity 0.2s ease;
}

.site-footer__link:hover {
    opacity: 0.65;
    text-decoration: underline;
}

.site-footer__bottom {
    border-top: 1px solid rgba(17, 17, 17, 0.12);
}

.site-footer__bottom-inner {
    align-items: center;
    color: #6a6762;
    display: flex;
    font-size: 12px;
    gap: 16px;
    justify-content: space-between;
    letter-spacing: 0;
    padding-bottom: 18px;
    padding-top: 18px;
    text-transform: uppercase;
}

@media (max-width: 900px) {
    .site-footer > .site-footer__shell:first-child {
        gap: 36px;
        grid-template-columns: 1fr;
        padding-bottom: 44px;
        padding-top: 44px;
    }

    .site-footer__identity {
        align-items: center;
    }

    .site-footer__columns {
        justify-self: stretch;
        max-width: none;
    }
}

@media (max-width: 640px) {
    .site-footer__shell {
        padding-left: 24px;
        padding-right: 24px;
    }

    .site-footer > .site-footer__shell:first-child {
        gap: 24px;
        padding-bottom: 28px;
        padding-top: 28px;
    }

    .site-footer__brand {
        width: 220px;
    }

    .site-footer__socials {
        margin-top: 18px;
    }

    .site-footer__links {
        gap: 10px;
    }

    .site-footer__link {
        font-size: 12px;
        line-height: 1.4;
        overflow-wrap: anywhere;
    }

    .site-footer__group-title {
        font-size: 13px;
        margin-bottom: 16px;
    }

    .site-footer__bottom-inner {
        align-items: center;
        flex-direction: row;
        font-size: 10px;
        gap: 16px;
        justify-content: space-between;
        letter-spacing: 0;
        padding-bottom: 16px;
        padding-top: 16px;
    }

    .site-footer__bottom-inner span {
        white-space: nowrap;
    }
}

@media (max-width: 380px) {
    .site-footer__shell {
        padding-left: 20px;
        padding-right: 20px;
    }

    .site-footer__columns {
        gap: 20px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .site-footer__link,
    .site-footer__social-link {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,gEAAgE;IAChE,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,gDAAgD;IAChD,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI;QACI,SAAS;QACT,0BAA0B;QAC1B,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,eAAe;QACf,SAAS;QACT,8BAA8B;QAC9B,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":[".site-footer {\n    background: #f3f3f1;\n    border-top: 1px solid rgba(17, 17, 17, 0.14);\n    color: #171717;\n}\n\n.site-footer__shell {\n    box-sizing: border-box;\n    margin: 0 auto;\n    max-width: 1360px;\n    padding: 0 24px;\n    width: 100%;\n}\n\n.site-footer > .site-footer__shell:first-child {\n    align-items: center;\n    display: grid;\n    gap: clamp(48px, 7vw, 104px);\n    grid-template-columns: minmax(240px, 0.8fr) minmax(480px, 1.2fr);\n    padding-bottom: 48px;\n    padding-top: 48px;\n}\n\n.site-footer__brand {\n    display: block;\n    width: clamp(220px, 18vw, 280px);\n}\n\n.site-footer__brand img {\n    aspect-ratio: 254 / 30;\n    display: block;\n    height: auto;\n    width: 100%;\n}\n\n.site-footer__identity {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.site-footer__socials {\n    display: flex;\n    gap: 8px;\n    margin-top: 24px;\n}\n\n.site-footer__social-link {\n    align-items: center;\n    color: #171717;\n    display: inline-flex;\n    height: 36px;\n    justify-content: center;\n    transition: opacity 0.2s ease;\n    width: 36px;\n}\n\n.site-footer__social-link:hover {\n    opacity: 0.6;\n}\n\n.site-footer__social-link[aria-disabled=\"true\"] {\n    cursor: default;\n}\n\n.site-footer__columns {\n    display: grid;\n    gap: clamp(40px, 5vw, 80px);\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    justify-self: end;\n    max-width: 720px;\n    width: 100%;\n}\n\n.site-footer__group-title {\n    color: #171717;\n    font-size: 15px;\n    font-weight: 500;\n    letter-spacing: 0;\n    margin: 0 0 22px;\n}\n\n.site-footer__links {\n    display: grid;\n    gap: 13px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.site-footer__link {\n    color: #171717;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 1.45;\n    text-decoration: none;\n    text-decoration-thickness: 1px;\n    text-underline-offset: 4px;\n    transition: opacity 0.2s ease;\n}\n\n.site-footer__link:hover {\n    opacity: 0.65;\n    text-decoration: underline;\n}\n\n.site-footer__bottom {\n    border-top: 1px solid rgba(17, 17, 17, 0.12);\n}\n\n.site-footer__bottom-inner {\n    align-items: center;\n    color: #6a6762;\n    display: flex;\n    font-size: 12px;\n    gap: 16px;\n    justify-content: space-between;\n    letter-spacing: 0;\n    padding-bottom: 18px;\n    padding-top: 18px;\n    text-transform: uppercase;\n}\n\n@media (max-width: 900px) {\n    .site-footer > .site-footer__shell:first-child {\n        gap: 36px;\n        grid-template-columns: 1fr;\n        padding-bottom: 44px;\n        padding-top: 44px;\n    }\n\n    .site-footer__identity {\n        align-items: center;\n    }\n\n    .site-footer__columns {\n        justify-self: stretch;\n        max-width: none;\n    }\n}\n\n@media (max-width: 640px) {\n    .site-footer__shell {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    .site-footer > .site-footer__shell:first-child {\n        gap: 24px;\n        padding-bottom: 28px;\n        padding-top: 28px;\n    }\n\n    .site-footer__brand {\n        width: 220px;\n    }\n\n    .site-footer__socials {\n        margin-top: 18px;\n    }\n\n    .site-footer__links {\n        gap: 10px;\n    }\n\n    .site-footer__link {\n        font-size: 12px;\n        line-height: 1.4;\n        overflow-wrap: anywhere;\n    }\n\n    .site-footer__group-title {\n        font-size: 13px;\n        margin-bottom: 16px;\n    }\n\n    .site-footer__bottom-inner {\n        align-items: center;\n        flex-direction: row;\n        font-size: 10px;\n        gap: 16px;\n        justify-content: space-between;\n        letter-spacing: 0;\n        padding-bottom: 16px;\n        padding-top: 16px;\n    }\n\n    .site-footer__bottom-inner span {\n        white-space: nowrap;\n    }\n}\n\n@media (max-width: 380px) {\n    .site-footer__shell {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .site-footer__columns {\n        gap: 20px;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .site-footer__link,\n    .site-footer__social-link {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
